import { isTaskInHistory, resolveTaskStatus } from '../helpers';
import { normalizeWallet } from '../formatting';
import { computeEarningsBreakdown } from './earningsMetrics';

export function getTasksForEmployee(tasks = [], employee) {
    const wallet = normalizeWallet(employee?.wallet);
    if (!wallet) return [];
    return tasks.filter(
        (task) => normalizeWallet(task.employee?.wallet) === wallet,
    );
}

export function splitEmployeeTaskLists(tasks = []) {
    const assigned = [];
    const completed = [];

    tasks.forEach((task) => {
        const status = resolveTaskStatus(task);
        if (isTaskInHistory(task) || status === 'released' || status === 'approved') {
            completed.push(task);
        } else {
            assigned.push(task);
        }
    });

    const byDateDesc = (a, b) =>
        new Date(b.updatedAt || b.createdAt || 0).getTime() -
        new Date(a.updatedAt || a.createdAt || 0).getTime();

    assigned.sort(byDateDesc);
    completed.sort(byDateDesc);

    return { assigned, completed };
}

/** Company employee profile — use company escrow totals (includes submitted/disputed). */
export function computeEmployeeWorkspaceMetrics(tasks = []) {
    const breakdown = computeEarningsBreakdown(tasks, 'company');
    const { assigned, completed } = splitEmployeeTaskLists(tasks);

    return {
        ...breakdown,
        assignedCount: assigned.length,
        completedCount: completed.length,
        totalTasks: tasks.length,
        assigned,
        completed,
    };
}
